<template>
  <div
    key="test-panel"
    class="mainpanel centerx w-full relative bg-black flex"
    :style="isBigScreen ? 'height: calc(100vh - 180px);':''"
  >
    <!-- Loading Screen -->
    <div
      v-show="loadingExam"
      id="mainpanel-loader"
      class="vs-con-loading__container loader"
    >
    </div>
    <!-- Loading Text -->
    <div v-if="loadingExam" class="_screens">
      <h3>{{ $t(`virtual-class.exam-preparing`) }}</h3>
    </div>

    <!-- Exam Screen -->
    <div v-else-if="examReady" class="bg-white w-full h-full overflow-y-auto">


      <!-- On exam completed -->
      <div v-if="examComplete" class="h-full w-full flex justify-center items-center flex-col">
        <p class="flex flex-row mb-8 items-center">
          <feather-icon icon="StarIcon" svgClasses="text-success h-10 w-10 mr-4 mt-1 p-0"/>
          <span class="text-xl text-success">{{ $t(`virtual-class.${examMode}-send-answer-done`) }}</span>
        </p>

        <vs-button v-if="examMode === 'pretest'" class="sm:w-4/5 lg:w-1/2 h-16 m-2" color="success" icon="icon-video"
                   icon-pack="feather" style="max-width: 400px;"
                   @click="handlerStartLearningClick">
          <span>{{ $t(`virtual-class.start-learning`) }}</span>
        </vs-button>

        <div>
          <p class="text-xl text-primary">
            {{ $t(`virtual-class.your-${examMode}-score`) }}
            <span class="text-xl3">
              {{
                examMode === 'pretest' ?
                  currentCourseOutlineUnit.studentUnitTest.pretestScore
                  : currentCourseOutlineUnit.studentUnitTest.posttestScore
              }}
            </span>
            of
            <span>
              {{
                examMode === 'pretest' ?
                  currentCourseOutlineUnit.studentUnitTest.pretestMaxScore
                  : currentCourseOutlineUnit.studentUnitTest.posttestMaxScore
              }}
            </span>
            {{ $t("virtual-class.score") }}
          </p>
        </div>
      </div>

      <!-- on exam finish -->
      <div v-else-if="examFinish"
           class="w-full flex justify-center items-center align-middle flex-col pt-10">
        <p class="flex flex-row mb-8 items-center">
          <feather-icon icon="CheckCircleIcon" svgClasses="text-warning h-10 w-10 mr-4 mt-1 p-0"/>
          <span class="text-xl text-warning">{{ $t(`virtual-class.${examMode}-send-answer-inform`) }}</span>
        </p>

        <div v-if="examProcessing">
          {{ $t(`virtual-class.${examMode}-send-answer-updating`) }}
        </div>

        <div v-else class="sm:w-4/5 lg:w-1/2 h-16 m-2" style="max-width: 400px;">
          <vs-button class="w-full" color="primary" icon="icon-send"
                     icon-pack="feather" @click="handlerFinishExamClick">
            <span>{{ $t(`virtual-class.${examMode}-send-answer`) }}</span>
          </vs-button>

          <vs-button class="w-full mt-4" color="warning" icon="icon-arrow-left"
                     icon-pack="feather" @click="handlerDoExamAgain">
            <span>{{ $t(`virtual-class.do-exam-again`) }}</span>
          </vs-button>
        </div>
      </div>

      <!-- Exam Doing -->
      <template v-else-if="examStart">

        <!-- Question No Top Nav-->
        <div class="vx-row w-full flex flex-inline justify-center mt-5 mx-auto px-5" >

          <div v-for="(question, index) in examQuestions" :key="index"
               class="flex justify-center items-center mb-2">

            <vs-divider v-if="index > 0" class="w-2 m-0" color="#cccccc"/>

            <div href="#" :class="getBadgeNavColor(index, question)"
                 class="cursor-pointer mx-0 flex justify-center items-center text-lg text-white"
                 :style="getBadgeNavSize(index, question)"
                 @click="handlerGoToExamClick(index)">
              <span class="text-sm"> {{ index + 1 }} </span>
            </div>
          </div>

          <vs-divider></vs-divider>

        </div>

        <!-- Question -->
        <div class="vx-row min-h-2/5 lg:min-h-2/4">
          <div class="w-full py-5 px-10">
            <div class="text-xl" v-html="currentQuestionIndex + 1 + '. ' + currentQuestion.examQuestion.nameLocal">
            </div>
          </div>

          <vs-divider class="mx-10"></vs-divider>
        </div>

        <!-- Selected Answer -->
        <!--          <div class="vx-row flex flex-wrap w-full justify-center items-end p-5 pl-12 sm:min-h-2/5"
                       style="height: 5rem;">
                    <transition name="fade">
                      <span class="text-lg"> {{ highlightAnswer }} </span>
                    </transition>
                  </div>-->

        <!-- Choices -->
        <div class="vx-row flex flex-wrap w-full justify-center items-end p-5 pl-12 sm:min-h-2/5">
          <template v-for="(answer, index) in currentQuestion.examQuestion.examAnswers">
            <div :key="answer.id"
                 :class="getSelectedAnswerBackground(answer)"
                 class="choice-button cursor-pointer vx-col w-full sm:w-1/1 md:w-1/2 lg:w-1/3 flex-grow mx-2 my-2 p-0 point flex flex-inline items-center hover:bg-success"
                 style="max-width: 400px; pointer-events: auto;"
                 @click="handlerSelectAnswerClick(answer, index)"
                 @mouseenter="handlerMouseEnter(answer)"
                 @mouseleave="handlerMouseLeave()">
              <vs-chip class="h-10 w-10 m-1" color="white">
                <span class="text-primary text-xl"> {{ index + 1 }} </span>
              </vs-chip>

              <span :class="getAnswerTextSize(answer)"
                    class="choice-text w-full pr-1"
              >
              {{ answer.nameLocal }}
            </span>
            </div>
          </template>
        </div>


        <!-- Exam Navigation -->
        <div v-if="examStart && !examComplete"
             class="vx-row flex flex-inline justify-between mx-auto">

          <!-- Back button -->
          <div class="vx-col w-1/3 flex justify-start ml-5">
            <vs-button
              v-if="currentQuestionIndex > 0 && examFinish === false"
              class="cursor-pointer" color="primary" icon="icon-arrow-left"
              icon-pack="feather" radius @click="handlerPreviousExamClick"></vs-button>
          </div>

          <!-- Submit Exam button -->
          <!--        <vs-button v-if="studentAnswers.every(x => x !== null && typeof x !== 'undefined')
                                    && examFinish === false"
                             class="cursor-pointer"
                             color="success" icon="icon-send" icon-pack="feather"
                             @click="handlerNextExamClick">
                    <span>{{ $t(`virtual-class.${examMode}-send-answer`) }}</span>
                  </vs-button>-->

          <!-- Next button -->
          <div class="vx-col w-1/3 flex justify-end mr-5">
            <vs-button v-if="currentQuestionIndex !== 0
                            && currentQuestionIndex < examQuestions.length - 1
                            && examFinish === false"
                       class="cursor-pointer pull-right"
                       color="primary" icon="icon-arrow-right" icon-pack="feather"
                       radius @click="handlerNextExamClick">
            </vs-button>
          </div>

        </div>

      </template>

      <!-- Before exam start -->
      <div v-else class="h-full w-full flex justify-center flex-col">

          <div class="mb-24 w-full flex justify-center flex-col items-center">
            <span>{{ $t(`virtual-class.${examMode}-title`) }}</span>
            <span class="text-xl">
              {{ $t('class-overview.unit-no') }} {{
                currentCourseOutlineUnit.seq
              }}. {{ currentCourseOutlineUnit.nameLocal }}
            </span>
            <span>{{ currentCourseOutlineUnit.descriptionLocal }}</span>
          </div>

          <div class="w-full flex justify-center">
            <vs-button class="sm:w-4/5 lg:w-1/2 h-16" color="primary" icon="icon-check-circle"
                       icon-pack="feather" style="max-width: 400px;" @click="handlerStartExamClick">
              <span>{{ $t(`virtual-class.start-${examMode}`) }}</span>
            </vs-button>
          </div>

        </div>

    </div>

    <!-- On some error occurs, Notify user properly -->
    <div v-else-if="loadingExamError"
         class="w-full h-full bg-white vx-row text-center items-center">
      <div class="vx-col w-full">
        <h3>{{ $t(`virtual-class.error-exam-generating`) }}</h3>
        <h3 class="mt-2">{{ $t(`virtual-class.staff-are-working`) }}</h3>
        <h3 class="mt-2">{{ $t(`virtual-class.try-again-later`) }}</h3>
<!--        <h3 v-if="examMode === 'pretest'" class="mt-2">{{ $t(`virtual-class.learning-start-in`) }}</h3>
        <h3 v-else class="mt-2">{{ $t(`virtual-class.try-again-later`) }}</h3>-->

      </div>
    </div>

  </div>
</template>

<script>
import store from '@/store';
import {createNamespacedHelpers} from "vuex";
import StudentUnitTest from "@/store/modules/student-unittest";

if (!store.state.StudentUnitTest) store.state.registerModule(`StudentUnitTest`, StudentUnitTest);

const {
  mapActions: mapStudentUnitTestActions,
} = createNamespacedHelpers(`StudentUnitTest`);

export default {
  name: "MainPanelUnitTest",
  props: [
    'studentEnrollDetail',
    'currentCourseOutlineUnit',
    'currentStudentUnitTest',
    'examMode',
    'isBigScreen',
  ],
  data() {
    return {
      loadingExam: false,
      loadingExamError: false,
      examComplete: false,
      examFinish: false,
      examStart: false,
      examProcessing: false,
      examQuestions: [],
      currentQuestion: {},
      currentQuestionIndex: 0,
      studentAnswers: [],

      highlightAnswer: null,
      currentExamState: {},
    }
  },
  watch: {
    currentQuestion: {
      handler: function (val) {
        if (val.length > 0) {
          val.map(exam => {
            this.currentExamState[exam.id] = false;
          })
        }
      },
      deep: true
    },
    loadingExam(val) {
      if (val === false) {
        this.loaderOn();
      } else {
        this.loaderOff();
      }
    },
    examProcessing(val) {
      if (val === false) {
        this.loaderOn();
      } else {
        this.loaderOff();
      }
    },
    async currentStudentUnitTest(val, preVal) {
      if (val.id !== preVal.id) {
        await this.loadData();
      }
    },
    async examMode(val, preVal) {
      if (val !== preVal) {
        await this.loadData();
      }
    }
  },
  computed: {
    examReady() {
      return !this.loadingExamError && this.examQuestions && this.examQuestions.length > 0
    }
  },
  methods: {
    ...mapStudentUnitTestActions({
      updateStudentUnitTest: 'updateStudentUnitTest',
      getStudentUnitPretests: 'getStudentUnitPretests',
      generateStudentUnitPretests: 'generateStudentUnitPretests',
      bulkCreateStudentUnitPretestAnswer: 'bulkCreateStudentUnitPretestAnswer',
      getStudentUnitPosttests: 'getStudentUnitPosttests',
      generateStudentUnitPosttests: 'generateStudentUnitPosttests',
      bulkCreateStudentUnitPosttestAnswer: 'bulkCreateStudentUnitPosttestAnswer',
    }),
    //--------------------------------------- Exam Function ------------------------------
    // action button function
    handlerStartExamClick() {
      this.examStart = true;
    },
    handlerSelectAnswerClick(answer, answerSeq) {
      this.studentAnswers[this.currentQuestionIndex] = {
        studentUnitTestId: this.currentStudentUnitTest.id,
        examQuestionId: this.currentQuestion.examQuestion.id,
        examAnswerId: answer.id,
        answerNo: parseInt(answer.no),
        answerSeq: answerSeq || 0,
        examAnswerNameLocal: answer.nameLocal,
        examAnswerNameEng: answer.nameEng,
      };
      if (this.examMode === "pretest") {
        this.studentAnswers[this.currentQuestionIndex].studentUnitPretestId = this.currentQuestion.id;
      } else if (this.examMode === "posttest") {
        this.studentAnswers[this.currentQuestionIndex].studentUnitPosttestId = this.currentQuestion.id;
      }

      this.checkNextExam();
      this.currentExamState[this.currentQuestion.id] = true;
    },
    handlerDoExamAgain() {
      this.examFinish = false;
    },
    async handlerFinishExamClick() {
      let result;
      this.examProcessing = true;
      if (this.examMode === 'pretest') {

        const payload = {
          studentUnitPretestAnswerCreateArray: this.studentAnswers
        };
        result = await this.bulkCreateStudentUnitPretestAnswer(payload);

      } else if (this.examMode === 'posttest') {

        const payload = {
          studentUnitPosttestAnswerCreateArray: this.studentAnswers
        };
        result = await this.bulkCreateStudentUnitPosttestAnswer(payload);

      }

      if (result) {
        //show result
        this.examFinish = false;
        this.examComplete = true;
        this.$emit('setDoingExam', false);

        //update student unit test to index page
        this.$emit('setNewStudentUnitTestToCourseOutlineUnits', result);
      }
      this.examProcessing = false;
    },
    handlerStartLearningClick() {
      this.$emit('startLearning', this.currentCourseOutlineUnit);
    },

    // navigate function
    checkNextExam() {
      //if answer all question then set exam finish = true
      if (this.studentAnswers.every(x => x !== null && typeof x !== 'undefined')
        && this.currentQuestionIndex === this.examQuestions.length - 1) {
        this.examFinish = true;
      } else if (this.currentQuestionIndex < this.examQuestions.length - 1) {
        this.handlerNextExamClick();
      } else {
        this.currentQuestionIndex = 0;
        this.currentQuestion = this.examQuestions[this.currentQuestionIndex];
      }
    },
    handlerNextExamClick() {
      if (this.examFinish === true) {
        this.examFinish = false;
      } else {
        this.currentQuestionIndex += 1;
        this.currentQuestion = this.examQuestions[this.currentQuestionIndex];
      }
    },
    handlerPreviousExamClick() {
      if (this.examFinish) {
        this.examFinish = false;
      } else {
        this.currentQuestionIndex -= 1;
        this.currentQuestion = this.examQuestions[this.currentQuestionIndex];
      }
    },
    handlerGoToExamClick(index) {
      this.currentQuestionIndex = index;
      this.currentQuestion = this.examQuestions[index];
    },

    // ui function
    handlerMouseLeave() {
      this.highlightAnswer = null;
    },
    handlerMouseEnter(answer) {
      this.highlightAnswer = answer.nameLocal;
    },
    getSelectedAnswerBackground(answer) {
      let selectedAnswer = this.studentAnswers[this.currentQuestionIndex]
      if (selectedAnswer && answer.id === selectedAnswer.examAnswerId) {
        return 'bg-success';
      } else {
        return 'bg-primary'
      }
    },
    getBadgeNavColor(index) {
      if (this.currentQuestionIndex === index) {
        return 'bg-warning'
      } else if (this.studentAnswers[index]) {
        return 'bg-success'
      } else {
        return 'bg-primary'
      }
    },
    getBadgeNavSize(index) {
      if (this.currentQuestionIndex === index) {
        return 'width: 29px; height: 29px; border-radius: 50%; z-index: 999;'
      } else {
        return 'width: 22px; height: 22px; border-radius: 50%; z-index: 999;'
      }
    },
    getAnswerTextSize(answer) {
      if (answer.nameLocal.length > 60) {
        return 'text-sm'
      } else if (answer.nameLocal.length > 40) {
        return 'text-md'
      } else {
        return 'text-lg'
      }
    },

    //--------------------------------------- Prepare Data Function ------------------------------
    async startTest(unit) {
      let studentUnitPreOrPostTestsResult;

      if (this.examMode === 'pretest') {
        // Check and load test exams
        // studentUnitPreOrPostTestsResult = await this.loadStudentUnitPreTest(unit);
        // if (studentUnitPreOrPostTestsResult || studentUnitPreOrPostTestsResult.length === 0) {
          //create if not exist
          studentUnitPreOrPostTestsResult = await this.createStudentUnitPreTest(unit);
        // }
      } else if (this.examMode === 'posttest') { // posttest
        // Check and load test exams
        // studentUnitPreOrPostTestsResult = await this.loadStudentUnitPostTest(unit);
        // if (studentUnitPreOrPostTestsResult || studentUnitPreOrPostTestsResult.length === 0) {
          //create if not exist
          studentUnitPreOrPostTestsResult = await this.createStudentUnitPostTest(unit);
        // }
      }

      if (studentUnitPreOrPostTestsResult && studentUnitPreOrPostTestsResult.length > 0) {
        //start test
        this.examQuestions = studentUnitPreOrPostTestsResult;
        this.prepareStudentAnswer(this.examQuestions);

        //set currentQuestion to first question
        this.currentQuestion = this.examQuestions[0];
        this.currentQuestionIndex = 0;

        this.$emit('setDoingExam', true);
      } else {
        this.loadingExamError = true;
        /*if(this.examMode === 'pretest'){
          // console.log('bypass in 5 second')
          //bypass to learning when no exam or can not creat exam
          setTimeout(async () => {
            await this.byPassPretest(unit);
          }, 5000);
        }*/
        this.$emit('setDoingExam', false);
      }

    },
    async byPassPretest(unit) {
      // console.log('byPassPretest to')
      unit.studentUnitTest.isPretestDone = true;
      // TODO remove comment when import all exam complete
      // update course outline unit at index page
      /*let result = this.updateStudentUnitPreTestComplete();
      if(result){
        await this.$emit('setNewStudentUnitTestToCourseOutlineUnits', result);
      }*/
      this.$emit('setDoingExam', false);
      this.$emit('startLearning', this.currentCourseOutlineUnit);
    },
    prepareStudentAnswer(examQuestions) {
      this.studentAnswers = new Array(examQuestions.length || 0).fill(null);
    },
    async loadStudentUnitPreTest(unit) {
      const payload = {
        studentUnitTestId: unit.studentUnitTest.id,
        studentEnrollDetailId: this.studentEnrollDetail.id,
        courseOutlineUnitId: unit.id
      };
      const result = await this.getStudentUnitPretests(payload);
      return result;
    },
    async createStudentUnitPreTest(unit) {
      const payload = {
        studentUnitTestId: unit.studentUnitTest.id,
        studentEnrollDetailId: this.studentEnrollDetail.id,
        courseOutlineUnitId: unit.id
      };
      const result = await this.generateStudentUnitPretests(payload);
      return result;
    },
    async updateStudentUnitPreTestComplete() {
      const payload = {
        id: this.currentStudentUnitTest.id,
        isPretestDone: true
      }
      await this.updateStudentUnitTest(payload);
    },
    async loadStudentUnitPostTest(unit) {
      const payload = {
        studentUnitTestId: unit.studentUnitTest.id,
        studentEnrollDetailId: this.studentEnrollDetail.id,
        courseOutlineUnitId: unit.id
      };
      const result = await this.getStudentUnitPosttests(payload);
      return result;
    },
    async createStudentUnitPostTest(unit) {
      const payload = {
        studentUnitTestId: unit.studentUnitTest.id,
        studentEnrollDetailId: this.studentEnrollDetail.id,
        courseOutlineUnitId: unit.id
      };
      const result = await this.generateStudentUnitPosttests(payload);
      return result;
    },
    async loadData() {
      this.$emit('setTriggerLoading', true);
      this.loaderOn();
      this.loadingExam = true;
      this.loadingExamError = false;
      this.examComplete = false;
      this.examFinish = false;
      this.examStart = false;

      await this.startTest(this.currentCourseOutlineUnit);

      this.loadingExam = false;
      this.loaderOff();
      this.$emit('setTriggerLoading', false);
    },

    //--------------------------------------- Local Data Function ------------------------------
    loaderOn() {
      if (this.$vs) {
        this.isLoaderActive = true;
        this.$vs.loading({container: '#mainpanel-loader', scale: 1})
      }
    },
    loaderOff() {
      if (this.$vs) {
        this.$vs.loading.close('#mainpanel-loader > .con-vs-loading')
        this.isLoaderActive = false;
      }
    },
  },
  async mounted() {
    await this.loadData();
  },
}
</script>

<style lang="scss">
.choice-button {
  position: relative;
  cursor: pointer !important;
  border-radius: 2rem;

  & > span {
   /* text-align: center;*/
    color: white;

    &.choice-text {
      //white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 80%;
      margin: auto;
    }
  }
}

.sub-debugger {
  position: absolute;
  color: white;
  z-index: 999999999;
  background: rgba(0, 0, 0, 0.6);
  top: 0;
  left: 0;
  max-height: 45vh;
  max-width: 100%;
  overflow-y: scroll;
  overflow-x: scroll;

  & > .content {
    width: 0;
    height: 0;
    margin: 20px;

    & > ._show {
      width: 98%;
      height: auto;
      overflow: hidden;
    }

    & > ._data-tree {
      margin: 20px;
    }
  }
}

.mainpanel {
  & ._screens {
    background: white;
    min-height: 500px;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

#mainpanel-loader {
  width: 100%;
  height: calc(100%);
  margin: auto;
  padding: 0;
  padding-bottom: 100px;
  border: 0;
  display: flex;
  justify-content: center;
  align-items: center;

  position: absolute;
  z-index: 999;
  background: #ffffff8c;

  & > .con-vs-loading {
    background: #ffffff96;
  }
}
</style>
